import Paginations from "components/Common/Pagination"
import IsLoading from "components/Shared/IsLoading"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Table } from "reactstrap"

import { getMatchedPracticalCandidates } from "store/actions/practicalTrainingAction"

const MatchedCandidates = ({ values }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    isMatching,
    practicalMatchedCandidates,
    perPage,
    totalPages1,
    currentPage1,
    totalCount1,
  } = useSelector(state => state.PracticalTraining)

  const pageNumber = 1

  useEffect(() => {
    const getAllData = page => {
      const { training_jobs } = values

      const data = {
        limit: perPage,
        page_number: page || pageNumber,
        order_by: 1,
        filters: {
          training_jobs,
        },
      }

      dispatch(getMatchedPracticalCandidates(data))
    }

    getAllData()
  }, [])

  const onPageChange = page => {
    getAllData(page)
  }

  return (
    <div>
      {isMatching ? (
        <IsLoading />
      ) : (
        <div className="table-responsive" style={{ maxHeight: "90vh" }}>
          {practicalMatchedCandidates?.length === 0 ? (
            <p className="text-center my-5 fs-4 font-bold">
              {t("No matching data found")}
            </p>
          ) : (
            <>
              <Table className="table mb-0">
                <thead className="table-light full_th">
                  <tr>
                    <th>{t("S. No.")}</th>
                    <th>{t("National Id")}</th>
                    <th>{t("Name")}</th>
                    {/* <th>{t("Email")}</th> */}
                    <th>{t("Phone Number")}</th>
                    <th>{t("Date of Birth")}</th>
                    <th>{t("Gender")}</th>
                    <th>{t("Nationality")}</th>
                    <th>{t("City")}</th>
                    <th>{t("Education Qualification")}</th>
                    <th>{t("Specialization")}</th>
                    <th>{t("Submitted Experience")}</th>
                    <th>{t("Assigned Job")}</th>
                  </tr>
                </thead>
                <tbody>
                  {practicalMatchedCandidates?.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.national_id}</td>
                      <td>{item?.full_name}</td>
                      {/* <td>{item?.email}</td> */}
                      <td>{item?.phone}</td>
                      <td>{item?.dob}</td>
                      <td className="text-capitalize">{item?.gender}</td>
                      <td>{item?.nationality_name}</td>
                      <td>{item?.city_name}</td>
                      <td>{item?.education_qualification_name}</td>
                      <td>{item?.specialization_name}</td>
                      <td>{item?.submit_experience === 1 ? "Yes" : "No"}</td>
                      <td className="fit_content">{item?.assign_job_title}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {!isMatching && practicalMatchedCandidates.length > 0 && (
                <Paginations
                  currentPage={currentPage1}
                  totalPages={totalPages1}
                  totalCount={totalCount1}
                  onPageChange={onPageChange}
                />
              )}
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default MatchedCandidates
